/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 31.07.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {Modal} from "../../../components/Bootstrap";
import t from "../../../trans";
import ViewRecord from "./ViewRecord";
import Navigation from "../../../Navigation";
import DataProvider from "../../../DataProvider";
import SchemaRegistry from "../../../services/SchemaRegistry";
import {PageActionActions, DeleteResourceAction} from "../../../services/PageAction";

class DeleteRecord extends ViewRecord {
    static propTypes = {
        params: PropTypes.shape({
            resource: PropTypes.string.isRequired,
            id: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentField: PropTypes.string
        }).isRequired,
        schema: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        let dataProvider = this.getDataProvider();
        let title = dataProvider.getTitle();

        return (
            <div className="text-center">
                {t("Delete ")} <b>{title}</b>?
            </div>
        );
    }
}

export default DeleteRecord;
